<template>
  <div class="app" v-title data-title="联系我们-广富林文化遗址公园">
    <component :is="headerComponent" :activeIndex="5" />
    <div class="lianxi-cont rel">
      <div class="lianxi-main w1200 auto df align_center justify_end">
        <div class="yj-banner-tit lx-banner-tit df align_center flex_column justify_center ts fw abs">
          <div class="f50 ls1 b">联系我们</div>
          <div class="f17 ls3">Contact Us</div>
        </div>
        <div class="lianxi-main-text lh20 rel">
          <div v-if="data && data.Items && data.Items.length > 0" v-html="data.Items[0].ContentText">
          </div>
          <!-- <div class="df align_center f16 fw mt10">
            <div>【咨询电话】：</div>
            <div>021-57800000</div>
          </div>
          <div class="df align_center f16 fw mt10">
            <div>【救助电话】：</div>
            <div>021-57800000</div>
          </div>
          <div class="df align_center f16 fw mt10">
            <div>【投诉电话】：</div>
            <div>021-57800000</div>
          </div>
          <div class="rel lianxi-main-site mt20 pt20">
            <div class="lianxi-main-line"></div>
            <div class="df align_center f16 fw mt10">
              <div>【地址】：</div>
              <div>上海市松江区广富林路2360弄</div>
            </div>
            <div class="df align_center f16 fw mt10">
              <div>【邮政编码】：</div>
              <div>201616</div>
            </div>
          </div> -->

          <div class="lx-icon">
            <img src="@/assets/images/lx-icon1.png" class="db" alt="">
          </div>
        </div>
      </div>
    </div>
    <component :is="bottomComponent" />
  </div>
</template>

<script>
import Header from '../../components/header.vue'
import Bottom from '../../components/bottom.vue'
import promotionService from '@/services/client/cont/promotion'

export default {
  name: 'app',
  data () {
    return {
      headerComponent: 'Header',
      bottomComponent: 'Bottom',
      code: 'app-lxwm-lxfs',
      data: null,
    }
  },
  components: { Header, Bottom,},
  mounted() {
    this.loadData();
  },
  methods:{
    loadData() {
      promotionService.detail(this.code).then(res => {
        if(res.Code == 200) {
          let data = res.Data;
          this.data = data;
        }
      })
    },
  },
}
</script>
<style>
  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
</style>



// WEBPACK FOOTER //
// src/views/lianxi/index.vue